export default "__VITE_ASSET__RWijHhGO__"